// src/utils/language.js

/**
 * Získá preferovaný jazyk uživatele.
 * Nejprve se kontroluje, jestli uživatel neuložil svou volbu v localStorage.
 * Pokud není uloženo, detekuje se výchozí jazyk podle hostname:
 * - Pokud hostname obsahuje "norisknodrift.cz", vrací se čeština ("cs")
 * - Jinak se vrací angličtina ("en")
 *
 * @returns {string} 'cs' nebo 'en'
 */
export const getUserLanguage = () => {
  // Zkontrolujeme, jestli uživatel nemá uloženou preferenci
  const storedLang = localStorage.getItem('preferred_language');
  if (storedLang) {
    return storedLang;
  }

  // Detekce na základě hostname
  const hostname = window.location.hostname;
  return hostname.includes('norisknodrift.cz') ? 'cs' : 'en';
};

/**
 * Vytvoří hlavičku pro nastavení jazyka na základě detekovaného jazyka.
 *
 * @returns {object} Objekt s klíčem 'accept-language'
 */
export const setLanguageHeader = () => {
  const lang = getUserLanguage();
  return { 'accept-language': lang };
};
